import { ContentCategoryService } from './../../content-category/content-category.service';
import { AddEmailTemplateComponent } from './../../add-email-template/add-email-template.component';
import { EmailerService } from './../../email-campaigning/emailer.service';
import { RepeatGuestService } from './../../reports/reportsComponents/repeat-guest/repeat-guest.service';
import { PropertyWiseSummaryService } from './../../reports/property-wise-summary/property-wise-summary.service';
import { ChangePasswordComponent } from './../../auth/change-password/change-password.component';
import { IReportsService } from './../../../iservices/iReportsServices/iReports';
import { IAlertService } from './../../../iservices/iAlert';
import { STORAGE_KEYS } from './../../../services/storage-keys-constants';
import { SharedService } from './../../../services/shared.service';
import { Component, DoCheck, OnDestroy, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { IUserService } from '../../../iservices/iUser';
import { ISocialMediaMasterService } from '../../../iservices/iMasterServices/iSocialMediaMaster';
import { IDepartmentService } from '../../../iservices/iMasterServices/iDepartment';
import { IDepartmentQueService } from '../../../iservices/iMasterServices/iDepartmentQue';
import { ICustomerTypeService } from '../../../iservices/iMasterServices/iCustomerType';
import { IPropertyTypeService } from '../../../iservices/iMasterServices/iPropertyType';
import { IReviewForService } from '../../../iservices/iMasterServices/iReviewFor';
import { IPropertyMasterService } from '../../../iservices/iMasterServices/iPropertyMaster';
import { IRangeTypeService } from '../../../iservices/iMasterServices/iRangeType';
import { IRangeService } from '../../../iservices/iMasterServices/iRange';
import { IPropertyRangeService } from '../../../iservices/iMasterServices/iPropertyRange';
// CRM
import { ICustomersService } from '../../../iservices/iCrmServices/iCustomers';
// setting
import { ISettingService } from '../../../iservices/iSettingServices/iSetting';
// Property Management
import { IPropertyService } from '../../../iservices/iPropertyMngServices/iProperty';
import { IPropertyDepartmentService } from '../../../iservices/iPropertyMngServices/iPropertyDepartment';
import { IPropertyDepartmentQueService } from '../../../iservices/iPropertyMngServices/iPropertyDepartmentQue';
import { IPropertyCustomerTypeService } from '../../../iservices/iPropertyMngServices/iPropertyCustomerType';
import { ISmsEmailApiService } from '../../../iservices/iPropertyMngServices/iSmsEmailApi';
import { IPropertyCustomerCategoryService } from '../../../iservices/iPropertyMngServices/iPropertyCustomerCategory';
// Cashier Report
import { ICashierReportService } from '../../../iservices/iCashierReportServices/iCashierReport';
// Reviews
import { IReviewsService } from '../../../iservices/iReviewsServices/iReviews';
// Promotion
import { IPromotionsService } from '../../../iservices/iPromotionServices/iPromotions';
import { ICurrentOfferService } from '../../../iservices/iPromotionServices/iCurrentOffer';

import { IELementMasterService } from '../../../iservices/iMasterServices/iElementMaster';
import { MatDialog } from '@angular/material/dialog';
import { ICommonService } from '../../../iservices/iCommon';
import { ILoaderService } from '../../../iservices/iLoader';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CommonPermissionsGuard } from '../../../gaurds/flow.guard';
import { NotificationService } from '../../master/masterComponents/notification/notification.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class TableComponent implements OnInit, DoCheck, OnDestroy {
  @Input()
  tableSettings: {
    id: string;
    tableHeader: any,
    serviceDetail: {
      isServiceNot: true,
      data: '',
      service: any,
      method: '',
      isParameter: boolean,
      dialogType: string,
      parameterList: any;
      notAllowPagination: any;
    },
    mapping: any,
    options: {
      pageSizeArray: [10, 20, 30, 50, 100];
    },
    searchData: {},
    menuList:
    { type: '', value: false },
  };
  prevSearchData: any;
  prevData: any;
  type: any;
  @Output() selectChecks = new EventEmitter<object>();
  @Output()
  pageTitleEvent = new EventEmitter<string>();
  dataService: any;
  dataMethod: any;
  isAllChecked: boolean;
  arrOfchecked = [];
  responseDataTable = [];
  size: any;
  page: any;
  totalItemCount: any;
  totalPages: any;
  currentPage: any;
  showMore: any;
  requestDataObj: {
    size: any,
    page: any,
    searchData: any,
    categoryId?: any,
  };
  showPagination: any;
  filtered: Array<any> = [];
  private tableSubscription: Subscription;
  private deleteSubscription: Subscription;
  @Output() count = new EventEmitter<number>();
  dataToFilterStorage: any[];
  constructor(
    @Inject('IUserService') private userService: IUserService,
    @Inject('ICommonService') private commonService: ICommonService,
    @Inject('IDepartmentService') private departmentService: IDepartmentService,
    @Inject('IDepartmentQueService') private departmentQueService: IDepartmentQueService,
    @Inject('ICustomerTypeService') private customerTypeService: ICustomerTypeService,
    @Inject('IPropertyTypeService') private propertyTypeService: IPropertyTypeService,
    @Inject('IReviewForService') private reviewForService: IReviewForService,
    @Inject('IPropertyMasterService') private propertyMasterService: IPropertyMasterService,
    @Inject('IRangeTypeService') private rangeTypeService: IRangeTypeService,
    @Inject('IRangeService') private rangeService: IRangeService,
    @Inject('IPropertyRangeService') private propertyRangeService: IPropertyRangeService,
    @Inject('ISocialMediaMasterService') private socialMediaMasterService: ISocialMediaMasterService,
    @Inject('IELementMasterService') private elementMasterService: IELementMasterService,

    @Inject('ICustomersService') private customersService: ICustomersService,

    @Inject('ICashierReportService') private cashierReportService: ICashierReportService,

    @Inject('IReportsService') private reportService: IReportsService,

    @Inject('IReviewsService') private reviewsService: IReviewsService,

    @Inject('ISettingService') private settingService: ISettingService,

    @Inject('IPromotionsService') private promotionsService: IPromotionsService,
    @Inject('ICurrentOfferService') private currentOfferService: ICurrentOfferService,


    @Inject('IPropertyService') private propertyService: IPropertyService,
    @Inject('IPropertyDepartmentService') private propertyDepartmenService: IPropertyDepartmentService,
    @Inject('IPropertyDepartmentQueService') private propertyDepartmenQueService: IPropertyDepartmentQueService,
    @Inject('IPropertyCustomerTypeService') private propertyCustomerTypeService: IPropertyCustomerTypeService,
    @Inject('ISmsEmailApiService') private smsEmailApiService: ISmsEmailApiService,
    @Inject('IPropertyCustomerCategoryService') private propertyCustomerCategoryService: IPropertyCustomerCategoryService,

    @Inject('ILoaderService') private loaderService: ILoaderService,
    @Inject('IAlertService') private alertService: IAlertService,
    private _propertyWiseSummary: PropertyWiseSummaryService,
    private _repeatGuestService: RepeatGuestService,
    public notificationService: NotificationService,
    public commonPermissionsGuard: CommonPermissionsGuard,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    public router: Router,
    private sharedService: SharedService,
    private emailerService: EmailerService,
    private contentCategoryService: ContentCategoryService) {
    this.type = this.sharedService.getDataFromStorage(STORAGE_KEYS.ROLE);
  }
  /**
   * @method ngOnInit()
   * @desc used to initilize page.
   */
  ngOnInit(): void {
    switch (this.tableSettings['serviceDetail']['service']) {
      case 'UserService':
        this.dataService = this.userService;
        break;
      case 'DepartmentService':
        this.dataService = this.departmentService;
        break;
      case 'DepartmentQueService':
        this.dataService = this.departmentQueService;
        break;
      case 'CustomerTypeService':
        this.dataService = this.customerTypeService;
        break;
      case 'PropertyTypeService':
        this.dataService = this.propertyTypeService;
        break;
      case 'ReviewForService':
        this.dataService = this.reviewForService;
        break;
      case 'PropertyMasterService':
        this.dataService = this.propertyMasterService;
        break;
      case 'RangeTypeService':
        this.dataService = this.rangeTypeService;
        break;
      case 'RangeService':
        this.dataService = this.rangeService;
        break;
      case 'PropertyRangeService':
        this.dataService = this.propertyRangeService;
        break;
      case 'SocialMediaMasterService':
        this.dataService = this.socialMediaMasterService;
        break;
      case 'CustomersService':
        this.dataService = this.customersService;
        break;
      case 'PropertyService':
        this.dataService = this.propertyService;
        break;
      case 'PropertyWiseSummaryService':
        this.dataService = this._propertyWiseSummary;
        break;
      case 'RepeatGuestService':
        this.dataService = this._repeatGuestService;
        break;
      case 'PropertyDepartmentService':
        this.dataService = this.propertyDepartmenService;
        break;
      case 'PropertyDepartmentQueService':
        this.dataService = this.propertyDepartmenQueService;
        break;
      case 'PropertyCustomerTypeService':
        this.dataService = this.propertyCustomerTypeService;
        break;
      case 'SmsEmailApiService':
        this.dataService = this.smsEmailApiService;
        break;
      case 'PropertyCustomerCategoryService':
        this.dataService = this.propertyCustomerCategoryService;
        break;
      case 'CashierReportService':
        this.dataService = this.cashierReportService;
        break;
      case 'ReportsService':
        this.dataService = this.reportService;
        break;
      case 'SettingService':
        this.dataService = this.settingService;
        break;
      case 'ReviewsService':
        this.dataService = this.reviewsService;
        break;
      case 'ElementMasterService':
        this.dataService = this.elementMasterService;
        break;
      case 'PromotionsService':
        this.dataService = this.promotionsService;
        break;
      case 'CurrentOfferService':
        this.dataService = this.currentOfferService;
        break;
      case 'NotificationService':
        this.dataService = this.notificationService;
        break;
      case 'EmailerService':
      this.dataService = this.emailerService;
      break;
      case 'ContentCategoryService':
      this.dataService = this.contentCategoryService;
      break;
      default:
        break;
    }
    if (!this.size) {
      this.size = this.tableSettings['options']['pageSizeArray']['0'];
    }
    if (!this.page) {
      this.page = 1;
    }
    if (this.dataService && !this.tableSettings['serviceDetail']['isServiceNot']) {
      this.dataMethod = this.tableSettings['serviceDetail']['method'];
      setTimeout(() => {
        this.searchData();
      });
      this.deleteSubscription = this.dataService.dataHasBeenDeleted.subscribe(beenDeleted => {
        // filter out non-truthy values
        if (beenDeleted) {
          setTimeout(() => {
            this.searchData();
          });
        }
      });
      this.tableSubscription = this.dataService.tableUpdated.subscribe(updated => {
        if (updated) {
          this.masterToggel();
          this.isAllChecked = false;
          setTimeout(() => {
            this.searchData();
          });
        }
      });
    }

    this.commonService.printDoc.subscribe((res) => {
      if (res) {
        this.print();
      }
    });
  }

  masterToggel(): void {
    this.arrOfchecked = [];
    if (this.isAllChecked) {
      this.responseDataTable.map(data => {
        data.map(ele => {
          if (ele.type === 'checkbox') {
            this.arrOfchecked.push(ele.selectionData || ele.dataId);
            ele.dataValue = true;
          }
        });
      });
    } else {
      this.responseDataTable.map(data => {
        data.map(ele => {
          if (ele.type === 'checkbox') {
            this.arrOfchecked = [];
            ele.dataValue = false;
          }
        });
      });
    }
    this.selectChecks.next(this.arrOfchecked);
  }

  checkboxVal(e, value): void {
    const customerId = value.selectionData || value.dataId;
    const isChecked = e.checked;
    if (isChecked) {
      this.arrOfchecked.push(customerId);
    } else {
      const index = this.arrOfchecked.findIndex(selected =>
        (selected.id || selected) === (customerId.id || customerId));
      if (index > -1) {
        this.arrOfchecked.splice(index, 1);
      }
    }
    this.selectChecks.next(this.arrOfchecked);
  }

  /**
   * @method ngDoCheck()
   * @desc used to check if any chaheges  detected.
   */
  ngDoCheck(): void {
    if (this.tableSettings['serviceDetail']['isServiceNot'] &&
      JSON.stringify(this.prevData) !==
      JSON.stringify(this.tableSettings['serviceDetail']['data'])) {
      this.prevSearchData = this.tableSettings.searchData;
      this.page = 1;
      setTimeout(() => {
        this.searchData();
      });
      this.prevData = this.tableSettings['serviceDetail']['data'];
    } else if (Object.keys(this.tableSettings.searchData).length &&
      JSON.stringify(this.prevSearchData) !==
      JSON.stringify(this.tableSettings.searchData)) {
      this.prevSearchData = this.tableSettings.searchData;
      this.page = 1;
      setTimeout(() => {
        this.searchData();
      });
    }
    // else if (Object.keys(this.tableSettings.menuList.value)) {
    //   this.searchData();
    // }
  }

  /**
   * @method ngOnDestroy()
   * @desc used to destory Observables detected.
   */
  ngOnDestroy() {
    if (this.tableSubscription) {
      this.tableSubscription.unsubscribe();
    }
    if (this.deleteSubscription) {
      this.deleteSubscription.unsubscribe();
    }
  }
  /**
   * @method searchData()
   * @desc used to get data of particular table using service and its methods.
   */
  searchData(): void {
    this.requestDataObj = {
      page: this.page,
      size: this.size,
      // returnWithoutMap: true,
      searchData: this.tableSettings.searchData
    };

    if (this.tableSettings['serviceDetail']['isParameter']) {
      if (this.tableSettings['serviceDetail']['parameterList']['searchData']) {
        this.requestDataObj = Object.assign(
          this.tableSettings['serviceDetail']['parameterList'], this.requestDataObj
        );
        this.requestDataObj.searchData = Object.assign(this.requestDataObj.searchData,
          this.tableSettings.searchData
        );
      } else {
        this.requestDataObj = Object.assign(
          this.tableSettings['serviceDetail']['parameterList'], this.requestDataObj
        );
      }
    }
    if (!this.tableSettings['serviceDetail']['isServiceNot']) {
      this.loaderService.display(true);
      this.showPagination = true;
      if (this.tableSettings['serviceDetail']['notAllowPagination']) {
        this.showPagination = false;
      }
      this.dataService[this.dataMethod](this.requestDataObj).subscribe(
        response => {
          this.loaderService.display(false);
          if (response.itemCount > 0) {
            this.responseDataTable = [];
            this.totalItemCount = response.itemCount;
            if (!this.size) {
              this.size = this.totalItemCount;
            }
            this.totalPages = Math.ceil(this.totalItemCount / this.size);
            this.dataToFilterStorage = [...response.data];
            this.dataMapping(response.data);
          }else if(response.data.length){
            this.totalItemCount = response.data.length;
            this.dataToFilterStorage = [...response.data];
            this.dataMapping(response.data);
          } else {
            this.responseDataTable = [];
            const data = {
              itemCount: 0,
              data: {}
            };
            this.dataMapping(data);
          }
        });
    } else {
      this.showPagination = false;
      this.loaderService.display(true);
      this.responseDataTable = [];
      this.totalItemCount = this.tableSettings['serviceDetail']['data'].length;
      this.totalPages = Math.ceil(this.totalItemCount / this.size);
      this.dataMapping(this.tableSettings['serviceDetail']['data']);
      this.loaderService.display(false);
    }
  }

  /**
   * @method dataMapping()
   * @desc Used to map response data to table Data.
   * @param response: object- response data from API.
   */
  dataMapping(response): void {
    for (const responseData of response) {
      const dataTable = [];
      let mappingDataObj: any;
      for (const mappingData of this.tableSettings.mapping) {
        switch (mappingData.type) {
          case 'anchor':
            mappingDataObj = Object.assign({}, mappingData);
            if (mappingData.urlArgument) {
              if (!this.route.snapshot.paramMap.get(mappingDataObj.dcIdCheck) &&
                responseData[mappingDataObj.optionalUrlArgument]) {
                mappingDataObj.urlValue = mappingDataObj.optionalUrlValue + '/' +
                  responseData[mappingDataObj.optionalUrlArgument] +
                  '/' + responseData[mappingDataObj.urlArgument] + '/'
                  + mappingDataObj.urlValue;
              } else {
                mappingDataObj.urlValue = responseData[mappingDataObj.urlArgument] + '/'
                  + mappingDataObj.urlValue;
              }
            }
            if (mappingData.concateFieldsArgument) {
              const cancateElements = [];
              for (const elementName of mappingData.concateFieldsArgument) {
                cancateElements.push(this.getDescendantProp(responseData, elementName)
                  ? this.getDescendantProp(responseData, elementName)
                  : mappingDataObj.dataValue);
              }
              mappingDataObj.dataValue = cancateElements.join('-');
            } else {
              mappingDataObj.dataValue = responseData[mappingDataObj.dataValue] ?
                responseData[mappingDataObj.dataValue] : mappingDataObj.dataValue;
            }
            dataTable.push(mappingDataObj);
            break;
          case 'concateFields':
            mappingDataObj = Object.assign({}, mappingData);
            if (mappingData.concateFieldsArgument) {
              const cancateElements = [];
              for (const elementName of mappingData.concateFieldsArgument) {
                cancateElements.push(this.getDescendantProp(responseData, elementName)
                  ? this.getDescendantProp(responseData, elementName)
                  : mappingDataObj.dataValue);
              }
              mappingDataObj.dataValue = cancateElements.join(' ');
            }

            mappingDataObj.type = 'default';

            dataTable.push(mappingDataObj);
            break;
          case 'anchor1':
            mappingDataObj = Object.assign({}, mappingData);
            if (mappingData.twoArguments) {
              const twoArguments = [];
              for (const elementName of mappingData.twoArguments) {
                twoArguments.push(this.getDescendantProp(responseData, elementName)
                  ? this.getDescendantProp(responseData, elementName)
                  : mappingDataObj.dataValue);
              }
              mappingDataObj.dataValue = twoArguments[0];
              mappingDataObj.dataValue1 = twoArguments[1];
            }
            dataTable.push(mappingDataObj);
            break;

          case 'button':
            mappingDataObj = Object.assign({}, mappingData);
            if (mappingData.urlArgument) {
              mappingDataObj.urlValue = this.getDescendantProp(responseData,
                mappingDataObj.urlArgument) ?
                this.getDescendantProp(responseData, mappingDataObj.urlArgument) + '/'
                + mappingDataObj.urlValue : '';
            }
            dataTable.push(mappingDataObj);
            break;
          case 'editPage':
            mappingDataObj = Object.assign({}, mappingData);
            if (mappingData.urlArgument) {
              mappingDataObj.urlValue = this.getDescendantProp(responseData,
                mappingDataObj.urlArgument) ?
                this.getDescendantProp(responseData, mappingDataObj.urlArgument) : '';
            }
            mappingDataObj.dataValue = this.getDescendantProp(responseData,
              mappingDataObj.dataValue) ?
              this.getDescendantProp(responseData, mappingDataObj.dataValue) : 0;
            dataTable.push(mappingDataObj);
            break;
          case 'numeric':
            mappingDataObj = Object.assign({}, mappingData);
            mappingDataObj.dataValue = this.getDescendantProp(responseData,
              mappingDataObj.dataValue) ?
              this.getDescendantProp(responseData, mappingDataObj.dataValue) : 0;
            mappingDataObj.type = 'default';
            dataTable.push(mappingDataObj);
            break;
          case 'isactive':
            mappingDataObj = Object.assign({}, mappingData);
            mappingDataObj.dataValue = this.getDescendantProp(responseData,
              mappingDataObj.dataValue) ?
              this.getDescendantProp(responseData, mappingDataObj.dataValue) : false;
            mappingDataObj.type = 'span';
            dataTable.push(mappingDataObj);
            break;
          case 'checkbox':
            mappingDataObj = Object.assign({}, mappingData);
            mappingDataObj.dataValue = this.getDescendantProp(responseData,
              mappingDataObj.dataValue) ?
              this.getDescendantProp(responseData, mappingDataObj.dataValue) : '';
            if (mappingDataObj.dataId) {
              mappingDataObj.dataId = this.getDescendantProp(responseData,
                mappingDataObj.dataId) ?
                this.getDescendantProp(responseData, mappingDataObj.dataId) : false;
            }
            if (mappingDataObj.selectionFields) {
              mappingDataObj.selectionData = { id: mappingDataObj.dataId };
              Object.keys(mappingDataObj.selectionFields).forEach(key => {
                const value = this.getDescendantProp(responseData,
                  mappingDataObj.selectionFields[key]);
                mappingDataObj.selectionData[key] = value === undefined ? null : value;
              });
            }
            dataTable.push(mappingDataObj);
            break;
          case 'input':
            mappingDataObj = Object.assign({}, mappingData);
            mappingDataObj.dataValue = this.getDescendantProp(responseData,
              mappingDataObj.dataValue) ?
              this.getDescendantProp(responseData, mappingDataObj.dataValue) : '';
            dataTable.push(mappingDataObj);
            break;
          case 'img':
            mappingDataObj = Object.assign({}, mappingData);
            mappingDataObj.dataValue = this.getDescendantProp(responseData,
              mappingDataObj.dataValue) ?
              this.getDescendantProp(responseData, mappingDataObj.dataValue) : '';
            dataTable.push(mappingDataObj);
            break;
          case 'strreplace':
            mappingDataObj = Object.assign({}, mappingData);
            mappingDataObj.dataValue = this.getDescendantProp(responseData,
              mappingDataObj.dataValue) ?
              this.getDescendantProp(responseData,
                mappingDataObj.dataValue).split(mappingDataObj.searchvalue)
                .join(mappingDataObj.newvalue) : '';
            mappingDataObj.type = 'default';
            dataTable.push(mappingDataObj);
            break;
          case 'datevale':
            mappingDataObj = Object.assign({}, mappingData);
            mappingDataObj.dataValue = this.getDescendantProp(responseData,
              mappingDataObj.dataValue) ?
              this.getFormattedDateAndTime(new Date(this.getDescendantProp(responseData,
                mappingDataObj.dataValue))) : '';
            mappingDataObj.type = 'default';
            dataTable.push(mappingDataObj);
            break;
          case 'date':
            mappingDataObj = Object.assign({}, mappingData);
            mappingDataObj.dataValue = this.getDescendantProp(responseData,
              mappingDataObj.dataValue) ?
              this.getFormattedDate(new Date(this.getDescendantProp(responseData,
                mappingDataObj.dataValue))) : '';
            mappingDataObj.type = 'default';
            dataTable.push(mappingDataObj);
            break;
          case 'priceType':
            mappingDataObj = Object.assign({}, mappingData);
            mappingDataObj.dataValue = this.getDescendantProp(responseData,
              mappingDataObj.dataValue) ?
              this.getDescendantProp(responseData, mappingDataObj.dataValue) : 0;
            mappingDataObj.type = 'priceType';
            dataTable.push(mappingDataObj);
            break;
          case 'orderStatus':
            mappingDataObj = Object.assign({}, mappingData);
            mappingDataObj.dataValue = this.getDescendantProp(responseData,
              mappingDataObj.dataValue) ?
              this.getDescendantProp(responseData, mappingDataObj.dataValue) : 'NA';
            mappingDataObj.type = 'orderStatus';
            dataTable.push(mappingDataObj);
            break;
          case 'capitalize':
            mappingDataObj = Object.assign({}, mappingData);
            mappingDataObj.dataValue = this.getDescendantProp(responseData,
              mappingDataObj.dataValue) ?
              this.getDescendantProp(responseData, mappingDataObj.dataValue) : 'NA';
            dataTable.push(mappingDataObj);
            break;
          case 'capitalizeWithAnchor':
            mappingDataObj = Object.assign({}, mappingData);
            if (mappingData.urlArgument) {
              mappingDataObj.urlValue = responseData[mappingDataObj.urlArgument] + '/'
                + mappingDataObj.urlValue;
            }
            if (mappingData.concateFieldsArgument) {
              const cancateElements = [];
              for (const elementName of mappingData.concateFieldsArgument) {
                cancateElements.push(this.getDescendantProp(responseData, elementName)
                  ? this.getDescendantProp(responseData, elementName)
                  : mappingDataObj.dataValue);
              }
              mappingDataObj.dataValue = cancateElements.join('-');
            } else {
              mappingDataObj.dataValue = responseData[mappingDataObj.dataValue] ?
                responseData[mappingDataObj.dataValue] : mappingDataObj.dataValue;
            }
            dataTable.push(mappingDataObj);
            break;
          case 'salesDivision':
            mappingDataObj = Object.assign({}, mappingData);
            mappingDataObj.dataValue = this.getDescendantProp(responseData,
              mappingDataObj.dataValue) ?
              this.getDescendantProp(responseData, mappingDataObj.dataValue) : [];
            dataTable.push(mappingDataObj);
            break;
          case 'qty':
            mappingDataObj = Object.assign({}, mappingData);
            mappingDataObj.dataValue = this.getDescendantProp(responseData,
              mappingDataObj.dataValue) ?
              this.getDescendantProp(responseData, mappingDataObj.dataValue) : 0;
            dataTable.push(mappingDataObj);
            break;
          case 'role':
            mappingDataObj = Object.assign({}, mappingData);
            mappingDataObj.dataValue = this.getDescendantProp(responseData,
              mappingDataObj.dataValue) ?
              this.getDescendantProp(responseData, mappingDataObj.dataValue) : 0;
            dataTable.push(mappingDataObj);
            break;
          case 'dialogWithPerm':
            mappingDataObj = Object.assign({}, mappingData);
            mappingDataObj.dataValue = this.getDescendantProp(responseData,
              mappingDataObj.dataValue) ?
              this.getDescendantProp(responseData, mappingDataObj.dataValue) : 'NA';
            if (mappingDataObj.dataValue1) {
              mappingDataObj.dataValue1 = this.getDescendantProp(responseData,
                mappingDataObj.dataValue1) ?
                this.getDescendantProp(responseData, mappingDataObj.dataValue1) : false;
            }
            if (mappingDataObj.dataValue2) {
              mappingDataObj.dataValue2 = this.getDescendantProp(responseData,
                mappingDataObj.dataValue2) ?
                this.getDescendantProp(responseData, mappingDataObj.dataValue2) : '';
            }
            dataTable.push(mappingDataObj);
            break;
            case 'dialog':
            mappingDataObj = Object.assign({}, mappingData);
            mappingDataObj.dataValue = this.getDescendantProp(responseData,
              mappingDataObj.dataValue) ?
              this.getDescendantProp(responseData, mappingDataObj.dataValue) : 0;
            if (mappingDataObj.dataValue1) {
              mappingDataObj.dataValue1 = this.getDescendantProp(responseData,
                mappingDataObj.dataValue1) ?
                this.getDescendantProp(responseData, mappingDataObj.dataValue1) : '';
            }
            dataTable.push(mappingDataObj);
            break;
          case 'dialogForSetting':
            mappingDataObj = Object.assign({}, mappingData);
            mappingDataObj.dataValue = this.getDescendantProp(responseData,
              mappingDataObj.dataValue) ?
              this.getDescendantProp(responseData, mappingDataObj.dataValue) : 'NA';
            if (mappingDataObj.dataValue1) {
              mappingDataObj.dataValue1 = this.getDescendantProp(responseData,
                mappingDataObj.dataValue1) ?
                this.getDescendantProp(responseData, mappingDataObj.dataValue1) : false;
              mappingDataObj.type = 'dialog';
            }
            dataTable.push(mappingDataObj);
            break;
          case 'html':
            mappingDataObj = Object.assign({}, mappingData);
            mappingDataObj.dataValue = responseData.offerDetails ?
              responseData.offerDetails : '';
            dataTable.push(mappingDataObj);
            break;
          default:
            mappingDataObj = Object.assign({}, mappingData);
            mappingDataObj.dataValue = this.getDescendantProp(responseData,
              mappingDataObj.dataValue) ?
              this.getDescendantProp(responseData, mappingDataObj.dataValue) : '';
            dataTable.push(mappingDataObj);
            break;
        }
      }
      this.responseDataTable.push(dataTable);
    }
  }

  /**
   * @method goPrev()
   * @desc used to get data of previous page.
   * @param data: object- contains table related info like page number.
   */
  goPrev(data): void {

    if (data.page <= this.totalPages) {
      this.page = data.page;
    }
    this.searchData();
  }

  /**
   * @method goNext()
   * @desc used to get data of next page.
   * @param data: object- contains table related info like page number.
   */
  goNext(data): void {


    if (data.page >= 1) {
      this.page = data.page;
    }
    this.searchData();
  }

  /**
   * @method goToPage()
   * @desc used to get data of current page.
   * @param data: object- contains table related info like page number.
   */
  goToPage(data): void {
    if (data.page >= 1 && data.page <= this.totalPages) {
      this.page = data.page;
    }
    this.searchData();
  }

  /**
   * @method setPageSize()
   * @desc used to set size to show number of items on page.
   * @param data: object- contains table related info like size.
   */
  setPageSize(data): void {
    this.page = 1;
    this.size = data.size;
    if (data.size === 'Select All') {
      this.size = 0;
    }
    this.searchData();
  }

  showMoreStates(): void {
    this.showMore = true;
  }

  setTitle(title): void {
    this.pageTitleEvent.emit(title);
  }
  getFormattedDateAndTime(date): any {
    const year = date.getFullYear();
    let month = (1 + date.getMonth()).toString();
    month = month.length > 1 ? month : '0' + month;
    let day = date.getDate().toString();
    day = day.length > 1 ? day : '0' + day;
    const hour = date.getHours();
    const minute = date.getMinutes();
    // const second = date.getSeconds();
    const hourFormatted = hour % 12 || 12; // hour returned in 24 hour format
    const minuteFormatted = minute < 10 ? '0' + minute : minute;
    const morning = hour < 12 ? 'AM' : 'PM';
    return month + '-' + day + '-' + year + ' | ' + hourFormatted + ':' +
      minuteFormatted + ' ' + morning;
  }
  getFormattedDate(date): any {
    const year = date.getFullYear();
    let month = (1 + date.getMonth()).toString();
    month = month.length > 1 ? month : '0' + month;
    let day = date.getDate().toString();
    day = day.length > 1 ? day : '0' + day;
    return month + '-' + day + '-' + year;
  }
  /**
   * @method trackByFn()
   * @desc to track the loop for current state.
   * @return null
   */
  trackByFn(): any {
    return null;
  }

  openReps(colData): void {
    // const url = this.router.url.replace('sd', 'emp');
    // this.router.navigate([url], { queryParams: { sd: colData.dataValue } });
  }

  /**
   * @method openAddDialog()
   * @desc to open a add dialog box.
   */
  openAddDialog(id, type): any {
    this.dataService.openAddDialog(id, type);
  }
  /**
   * @method openDialog()
   * @desc to open a dialog box.
   */

  openDialog(userId, dialogType): any {
    this.commonService.openDialog(userId, this.dataService, dialogType);
  }

  /*
   * @method openDialogEdit()
   * @desc used to open modal.
   * @param userId: id- contains mapping data.
   */
  openDialogEdit(userId, dialogType, param?): any {
    this.dataService.openDialog(userId, dialogType, param);
  }

  addEmailTemplate(res?): void {
    const dialogRef =  this.dialog.open(AddEmailTemplateComponent, {
      width: window.innerWidth + 'px',
      height: window.outerHeight + 'px',
      panelClass: ['mat-dialog-box', 'full-screen-popup-2', 'point-view'],
      data: res
    });
    dialogRef.afterClosed().subscribe((result) => {
    });
  }

  openDialogDemo(data, param?: string): any {
    const popupData = data;
    if (data.dialogType === 'misscallConfig') {
      this.propertyService.editMisscallData.next(data);
    } else if (data.dialogType === 'autoPilotReward') {
      this.propertyService.editNoOfDays.next(data);
    } else if (!param) {
      const dialogRef =  this.dialog.open(popupData.loadComponent, {
        width: popupData.width,
        panelClass: popupData.panelClass,
        data: {
          rowId: popupData.dataValue,
          param: popupData.dataValue1
        }
      });
      if (data.dialogType === 'EmailerCategory') {
        dialogRef.afterClosed().subscribe((result) => {
          if (!_.isEmpty(result)) {
            this.addEmailTemplate(result);
          }
        });
      }
    }
    if (param === 'QR') {
      this.dialog.open(popupData.loadComponent2, {
        width: popupData.width2,
        panelClass: popupData.panelClass2,
        data: {
          rowId: popupData.dataValue,
          param: popupData.dataValue1
        }
      });
    }
    if (param === 'CONFIG') {
      this.dialog.open(popupData.loadComponent3, {
        width: popupData.width2,
        panelClass: popupData.panelClass2,
        data: {
          rowId: popupData.dataValue,
          param: popupData.dataValue1
        }
      });
    }
    if (param === 'more') {
      this.router.navigate([`reports/property-wise-summary/property-wise-customer-summary/${popupData.dataValue}`]);
    }
  }

  triggerAction = (colData) => {
    this.dialog.open(colData.loadComponent, {
      width: colData.width,
      panelClass: colData.panelClass,
      data: {
        id: colData.dataValue1,
        type: colData.modelType,
        ScheduleId: colData.dataValue2,
        searchData: this.prevSearchData
      }
    });
  }
  /*
   * @method print()
   * @desc used to open modal.
   * @param data: object- contains mapping data.
   */

  print(): void {
    let printContents, popupWin;
    printContents = document.getElementById(this.tableSettings['id']).innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>Print tab</title>
         <style>body{font-size:.75rem;color:#000!important;overflow-x:hidden;
          font-family:Calibri,sans-serif!important;position:relative;width:21cm;height:29.7cm;margin:0 auto}
          div{display:block}.row{display:flex;flex-wrap:wrap;padding-right:5px;padding-left:5px}
          .col-md-12{flex:0 0 100%;max-width:100%}.col-md-3{flex:0 0 25%;max-width:25%}
          .col-md-3{flex:0 0 25%;max-width:25%}.col-md-4{flex:0 0 33.333333%;max-width:33.333333%}
          .col-md-6{flex:0 0 50%;max-width:50%}.col,.col-1,.col-10,.col-11,.col-12,.col-2,.col-3,.col-4,.col-5,.col-6,.col-7,.col-8,.col-9,.col-auto,.col-lg,.col-lg-1,.col-lg-10,.col-lg-11,.col-lg-12,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-auto,.col-md,.col-md-1,.col-md-10,.col-md-11,.col-md-12,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-auto,.col-sm,.col-sm-1,.col-sm-10,.col-sm-11,.col-sm-12,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-auto,.col-xl,.col-xl-1,.col-xl-10,.col-xl-11,.col-xl-12,.col-xl-2,.col-xl-3,.col-xl-4,.col-xl-5,.col-xl-6,.col-xl-7,.col-xl-8,.col-xl-9,.col-xl-auto{position:relative;width:100%;min-height:1px}.justify-content-center{justify-content:center!important}.bdr_left{border-left:1px solid #000}.bdr_right{border-right:1px solid #000}.bdr_top{border-top:1px solid #000}.bdr_bottom{border-bottom:1px solid #000}.text-center{text-align:center!important}.text-right{text-align:right!important}.text-left{text-align:left!important}.p-2{padding:.5rem!important}.p-1{padding:.25rem!important}.font-weight-bold{font-weight:700!important}.name_size{font-size:22px}.amount_bs{text-align:right;padding:0 3px}.main-balance .tfoot,.main-balance .thead{font-weight:600;padding:5px 3px;font-size:.8rem;border-top:1px solid #000;border-bottom:1px solid #000}.col-3{flex:0 0 25%;max-width:25%}.col{flex-basis:0;flex-grow:1;max-width:100%}.p-0{padding:0!important}.ittelic{font-style:italic}*,::after,::before{box-sizing:border-box}.bdr_right_fix{min-height:25px;border-right:1px solid #000}.bdr_left_fix{min-height:25px;border-left:1px solid #000}.d-block{display:block}table{width:100%;border-collapse:collapse;border-spacing:0;margin-bottom:20px}thead{display:table-header-group;vertical-align:middle;border-color:inherit}table td,table th{padding:3px;text-align:left;border-bottom:1px solid #fff;word-break:break-word}table th{white-space:nowrap;font-weight:600;font-size:.8rem;border:1px solid #000;background-color:#000!important;color:#fff!important;text-align:center}tr:nth-child(even){background-color:#d9e1f2}table td{text-align:left;border:1px solid #000;font-size:.75rem;}@media print{table th{background-color:#000!important;-webkit-print-color-adjust:exact}tr:nth-child(even){background-color:#d9e1f2;-webkit-print-color-adjust:exact}}
          @media print{table th{color:#fff!important}}
          </style>
        </head>
    <body onload="window.print();window.close()">${printContents}</body>
      </html>`
    );
    popupWin.document.close();
  }

  /**
   * @method getDescendantProp()
   * @desc to format data.
   * @return object
   */
  private getDescendantProp(obj, desc): any {
    const arr = desc.split('.');
    while (arr.length && (obj = obj[arr.shift()])) {
      //
    }
    return obj;
  }
  /**
   * @method dateFun()
   * @desc to format date to MM/dd/yyyy.
   * @return date object
   */
  dateFun(date) {
    const d1 = date;
    const d2 = d1.replace(/^(\d{1,2}\/)(\d{1,2}\/)(\d{4})$/, '$2$1$3');
    return new Date(d2);
  }

  login(userId) {
    this.userService.directLoginUser(userId).subscribe(res => {
      if (res.code === 1000) {
        this.loaderService.display(false);
        const role = this.sharedService.getDataFromStorage(STORAGE_KEYS.ROLE);
        if (role !== 'cashier') {
          this.router.navigate(['dashboard']);
          this.userService.directLogin.next(true);
        } else {
          const isCompleteForm = this.sharedService.getDataFromStorage('allowCompleteFormView') === 'true' ? true : false ;
              if (isCompleteForm) {
                this.router.navigate(['/cashierreports']);
              } else {
                this.router.navigate(['/cashierreport']);
              }
        }
        this.alertService.success('1000', false);
      } else if (res.code === 5003) {
        this.alertService.error('INVALIDUSERLOGIN', false);
        this.loaderService.display(false);
      } else {
        this.alertService.error('INVALIDUSERLOGIN', false);
        this.loaderService.display(false);
      }
    },
      error => {
        if (error.status === 403) {
          this.alertService.error('USERDIFFERENTPORTAL', false);
        } else if (error.status === 422) {
          error.error.fieldErrors.forEach(element => {
            console.log(element.message);
          });
        } else if (error.status === 401) {
          // this.alertService.error('INVALIDUSERLOGIN', false);
        } else {
          this.alertService.error('INVALIDUSERLOGIN', false);
        }
        this.loaderService.display(false);
      });
  }

  changePassword = (data) => {
    this.dialog.open(ChangePasswordComponent, {
      width: '',
      disableClose: true,
      panelClass: ['mat-dialog-box', 'mid-hr-ver-popup'],
      data: {
        userData: data,
        from: 'admin'
      }
    });
  }

  filterDataByOrder = (isFilter, order, columnIndex) => {
    if (!isFilter) {
      return;
    } else {
      const orderType = order ? 'desc' : 'asc';
      const object = this.responseDataTable[0][columnIndex];
      if (!_.isEmpty(object) && object['key']) {
        let data = [];
        this.filtered[columnIndex] = !this.filtered[columnIndex];
        if (_.isString(object['dataValue'])) {
          data = _.orderBy(this.dataToFilterStorage, [user => user[object['key']].trim().toLowerCase()], [orderType]);
        } else {
          data = _.orderBy(this.dataToFilterStorage, [object['key']], [orderType]);
        }
        this.responseDataTable = [];
        this.dataMapping(data);
      }
    }
  }
}
